import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';

export const carouselBehavior = () => {
  Alpine.data('carouselBehavior', (visibleItemCount = 6, itemGap = '2rem') => ({
    carousel: undefined,
    carouselIsShowing: false,
    perPage: visibleItemCount,
    gap: itemGap,
    init() {
      // When modal appears, refresh carousel to ensure its on the correct slide.
      this.watch('carouselIsShowing');
      this.initSlider();
    },
    initSlider() {
      // Create new splide instance for carousel if one hasn't been created already.
      let hasParentCarousel = false;
      if (this.$store.carouselStatus && this.$store.carouselStatus.parentCarousel) {
        hasParentCarousel = true;
      } else {
        hasParentCarousel = false;
      }
      if (this.carousel === undefined && !hasParentCarousel) {
        this.carousel = new Splide(this.$el, {
          rewind: true,
          pagination: true,
          arrows: false,
          type: 'loop',
          drag: 'free',
          perPage: 3,
          mediaQuery: 'min',
          focus: 'center',
          gap: '0.5rem',
          breakpoints: {
            768: {
              perPage: this.perPage,
              gap: this.gap,
            },
          },
        });

        this.carousel.mount();
      }
    },
    watch(property) {
      this.$watch(property, (newValue) => {
        if (newValue === true) {
          setTimeout(() => {
            this.refreshCarousel();
          }, 50);
        }
      });
    },
    refreshCarousel() {
      if (this.carousel !== undefined) {
        this.carousel.refresh();
      }
    },
  }));
};
